<template>
  <validation-observer ref="findingCommentRef" novalidate tag="form">
    <div class="mx-4">
      <div class="row">
        <div class="col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="my-3">
              <em class="fas fa-comment text-orange mr-1" />
              <span class="pl-1">Comentario</span>
            </div>
            <custom-text-area
              v-model="comment"
              custom-error-msg="Es requerido documentar un comentario."
              :error="errors[0]"
              :maxlength="2000"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-5 mt-md-0 mt-sm-3 pb-3 pt-3">
        <div
          class="col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
        >
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger px-3 mr-2"
            @click="onCancel()"
          >
            Cancelar
          </action-button>
          <action-button
            i="fas fa-save"
            variant="success px-3"
            @click="onConfirm()"
          >
            Guardar
          </action-button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'FindingComment',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alertMixin],
  data: () => ({
    comment: null,
  }),
  methods: {
    onCancel() {
      this.$emit('on-cancel');
    },
    async onConfirm() {
      const isValid = await this.$refs.findingCommentRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
      this.$emit('on-confirm', this.comment);
    },
  },
};
</script>
